import HttpService from '@src/utils/http';
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
let http = new HttpService();

export const bindInviteCode = async (data) => {
  let res = await http.post('/activity/activity-invite/bindInviteCode', data);
  return res;
}



// WEBPACK FOOTER //
// ./src/pages/inviteCodePage/scripts/services.js